import { useMutation } from '@tanstack/react-query';

import { deleteClubProfile } from './request';

export const useDeleteClubMutation = () =>
  useMutation({
    mutationKey: ['deleteClub'],
    mutationFn: deleteClubProfile
  });
